import { ToastProvider } from '@ibe/ui-web';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AnalyticsProvider } from '@ibe/analytics';

import { ApiProvider } from '../shared/api/api-context.js';
import { ApiClient } from '../shared/api/api-client.js';
import { BookingProvider } from '../features/booking/state/booking-context.js';
import { ContentTranslationProvider } from '../shared/content-translation.js';
import { CurrencyProvider } from '../shared/currency-context.js';
import { LanguageProvider } from '../shared/language-context.js';
import { SiteProvider } from '../shared/site-context.js';
import { createQueryClient } from '../shared/query/query-client.js';
import { AppRoutes } from './routes.js';

const GATEWAY_URL = ((): string => {
  const fromEnv = import.meta.env.VITE_GATEWAY_URL as string | undefined;
  if (fromEnv !== undefined) return fromEnv;

  if (typeof window === 'undefined') {
    return 'http://localhost:3000';
  }

  if (import.meta.env.DEV as boolean | undefined) {
    return `${window.location.protocol}//${window.location.hostname}:3000`;
  }

  return window.location.origin;
})();

const apiClient = new ApiClient({
  baseUrl: GATEWAY_URL,
});

const queryClient = createQueryClient();

export function App(): React.JSX.Element {
  return (
    <ApiProvider client={apiClient}>
      <CurrencyProvider>
        <LanguageProvider>
          <SiteProvider>
            <ContentTranslationProvider>
              <QueryClientProvider client={queryClient}>
                <BookingProvider>
                  <AnalyticsProvider baseUrl={GATEWAY_URL}>
                    <ToastProvider>
                      <BrowserRouter>
                        <AppRoutes />
                      </BrowserRouter>
                    </ToastProvider>
                  </AnalyticsProvider>
                </BookingProvider>
              </QueryClientProvider>
            </ContentTranslationProvider>
          </SiteProvider>
        </LanguageProvider>
      </CurrencyProvider>
    </ApiProvider>
  );
}
